const module = { name: 'shared/offerModal', exports: {} }; const exports = module.exports;



const Selectors = {
    TERMS_TOGGLE: '.offer-modal__terms-toggle',
    TERMS_AND_CONDITIONS: '.offer-modal__terms-and-conditions',
    MODAL_CONTENT: '.offer-modal__content',
    LEGAL_WRAP: '.offer-modal__legal-wrap',
}
function handleTermsToggle(e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    const modalContent = e.target.closest('.offer-modal__content');
    const termsAndConditions = modalContent.querySelector(Selectors.TERMS_AND_CONDITIONS);
    const termsToggle = modalContent.querySelector(Selectors.TERMS_TOGGLE);
    const isHidden = window.getComputedStyle(termsAndConditions).display === 'none';
    termsAndConditions.style.display = isHidden ? 'block' : 'none';
    termsToggle.style.display = isHidden ? 'none' : 'block';
}
function resetModalState(modalElement) {
    const modalContent = modalElement.querySelector(Selectors.MODAL_CONTENT);
    if (modalContent) {
        const termsAndConditions = modalContent.querySelector(Selectors.TERMS_AND_CONDITIONS);
        const termsToggle = modalContent.querySelector(Selectors.TERMS_TOGGLE);
        const legalWrap = modalContent.querySelector(Selectors.LEGAL_WRAP);
        if (termsAndConditions && termsToggle) {
            termsAndConditions.style.display = 'none';
            termsToggle.style.display = 'block';
        }
        if (legalWrap && termsAndConditions) {
            const termsText = termsAndConditions.textContent;
            legalWrap.style.display = (termsText && termsText.trim()) ? '' : 'none';
        }
    }
}
function init() {
    const termsToggles = document.querySelectorAll(Selectors.TERMS_TOGGLE);
    termsToggles.forEach((termsToggle) => {
        const newTermsToggle = termsToggle.cloneNode(true);
        termsToggle.parentNode.replaceChild(newTermsToggle, termsToggle);
        newTermsToggle.addEventListener('click', handleTermsToggle);
    });
    const modals = document.querySelectorAll('.dialog');
    modals.forEach((modal) => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'aria-hidden') {
                    if (modal.getAttribute('aria-hidden') === 'false') {
                        resetModalState(modal);
                    }
                    else if (modal.getAttribute('aria-hidden') === 'true') {
                        resetModalState(modal);
                    }
                }
            });
        });
        observer.observe(modal, { attributes: true });
    });
}
module.exports = {
    init,
};
export default module.exports;